export default "__VITE_ASSET__rVMp1MIV__"